import { render, staticRenderFns } from "./SelectWarehouse.vue?vue&type=template&id=8c1405d6&"
import script from "./SelectWarehouse.vue?vue&type=script&lang=js&"
export * from "./SelectWarehouse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports